import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a7a918cc")

_pushScopeId("data-v-a7a918cc")
const _hoisted_1 = { class: "flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置搜索条件")
const _hoisted_4 = { class: "container col flex-center" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("授权")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_8 = { class: "flex-center margin-top-10" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_search_input = _resolveComponent("search-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        class: "name-search",
        placeholder: "昵称关键字",
        modelValue: _ctx.nameKeyword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.nameKeyword = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_search_input, {
        modelValue: _ctx.phoneKeyword,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.phoneKeyword = $event)),
        placeholder: "手机号",
        onSearch: _ctx.handleSearch
      }, null, 8, ["modelValue", "onSearch"]),
      _hoisted_2,
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        class: "margin-right-10",
        onClick: _ctx.reset
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData.content,
        height: "100%",
        class: "w-full"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            prop: "username",
            label: "用户名"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "昵称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "phone",
            label: "手机号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "roles",
            label: "角色"
          }, {
            default: _withId(({row}) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.roles, (role) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: row.id + '-' + role
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.getRoleName(role)), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "140"
          }, {
            default: _withId(({row}) => [
              _createVNode("div", _hoisted_5, [
                (!row.isEditing)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      class: "margin-right-10",
                      onClick: ($event: any) => (_ctx.handleRowClick(row)),
                      type: "primary"
                    }, {
                      default: _withId(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _hoisted_7,
      _createVNode(_component_el_pagination, {
        class: "margin-top-10",
        total: _ctx.tableData.totalCount,
        "page-count": _ctx.tableData.totalPages,
        "current-page": _ctx.tableData.pageNumber,
        onCurrentChange: _ctx.reloadPage,
        onPrevClick: _ctx.reloadPage,
        onNextClick: _ctx.reloadPage,
        background: "",
        layout: "total, prev, pager, next, jumper"
      }, null, 8, ["total", "page-count", "current-page", "onCurrentChange", "onPrevClick", "onNextClick"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "编辑角色",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roles, (role, index) => {
            return (_openBlock(), _createBlock(_component_el_checkbox, {
              key: role,
              modelValue: _ctx.currentRoles[index].selected,
              "onUpdate:modelValue": ($event: any) => (_ctx.currentRoles[index].selected = $event)
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(role.roleName), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]))
          }), 128)),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.submit
            }, {
              default: _withId(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible=false))
            }, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})